export enum AuthErrorDataCode {
  Invalid = 'invalid',
  ErrorLimit = 'error_limit',
  ErrorLimitTotal = 'error_limit_total',
  ErrorCode = 'error_code',
  AttemptsOut = 'attempts_out',
  DeletingInProgress = 'deleting_in_progress',
  RecaptchaRequired = 'recaptcha_required', // TODO[sff_use_yandex_captcha]: удалить
  RecaptchaInvalid = 'invalid_recaptcha', // TODO[sff_use_yandex_captcha]: удалить
  CaptchaRequired = 'captcha_required',
  CaptchaInvalid = 'invalid_captcha',
  PhoneNotMobile = 'phone_not_mobile',
  PhoneChangeRequestExists = 'phone_change_request_exists',
  AuthorizationOutgoingCallAttemptsExceed = 'authorization_outgoing_call_attempts_exceed',
  PhoneNotLinked = 'phone_not_linked',
  ForeignCountryPhone = 'foreign_country_phone',
  MasterPasswordRequired = 'master_password_required',
  MasterPasswordAttemptsExceeded = 'master_password_attempts_exceeded'
}

export enum AuthResendButtonType {
  Vk = 'vk',
  Sms = 'sms',
  Call = 'call',
  LastCall = 'lastCall',
  LastSms = 'lastSms',
  Banned = 'banned'
}

export enum AuthMethod {
  Vk = 'vk',
  Call = 'only_call',
  Tg = 'tg',
  Mt = 'mt',
  CallCode = 'call_code',
  OutgoingCall = 'out_going_call',
  WhatsApp = 'whatsapp',
  Max = 'max',
  WbId = 'wb_id',
  MobileId = 'mobile_id',
  VkId = 'vk_id',
  YandexId = 'yandex_id'
}

export enum MobileIdConfirmationStatus {
  Waiting = 'waiting',
  Confirmed = 'confirmed',
  SmsOtp = 'sms_otp',
  Failed = 'failed'
}
